module.exports = __webpack_public_path__ + "static/img/icon_jrxh.c8d566e3.png";